<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fas fa-layer-group"></i>
        Setting
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">System</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Setting</a>
        </li>
      </ul>
    </div>
    <!-- 시스템 설정임 -->
    <b-card no-body border-variant="warning">
      <b-tabs class="" v-model="index" content-class="mt-3" fill justified>
        <b-tab :title="model.license.code.toUpperCase()" active v-if="model.license.code">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              LICENSE
            </div>
          </div>
          <hr>
          <div class="row mb-2">
            <div class="col-xl-12 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="Company">
                F1-UWSS License, Expire :
                <span class="text-danger px-2">{{model.license.data.summary.expire | datetime}}</span>
                If you will change setting, Applies at least 30 minutes later.
              </label>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-xl-2 col-md-12 d-flex align-self-center">
              <label class="col-form-label" for="OnPremise">
                OnPremise
              </label>
            </div>
            <div class="col-xl-10 col-md-12 d-flex align-self-center">
              <div class="checkbox-switch">
                  <input type="checkbox" class="input-checkbox" name="OnPremise" id="OnPremise" checked="" :disabled="true" v-if="model.license.data.summary.Group" v-model="model.license.data.summary.Group.use">
                  <div class="checkbox-animate disabled">
                      <span class="checkbox-off">OFF</span>
                      <span class="checkbox-on">ON</span>
                  </div>
              </div>
              <div class="ml-2">* If it's OnPremise, you can't issue an invoice or pay for credit automatically.</div>
            </div>
          </div>
          <hr>
          <b-row v-if="model.license.data.summary.Group">
            <b-col md="2" class="col-form-label" for="Group"> Group <small>(Max)</small> </b-col>
              <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
                <!-- <c-switch :disabled="true" v-if="model.license.data.summary.Group" color="info" label v-model="model.license.data.summary.Group.use" /> -->
                <div class="checkbox-switch">
                  <input type="checkbox" class="input-checkbox" name="Group" id="Group" checked="" :disabled="true" v-if="model.license.data.summary.Group" v-model="model.license.data.summary.Group.use">
                  <div class="checkbox-animate disabled">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                  </div>
                </div>
              </b-col>
              <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.Group" v-model="model.license.data.summary.Group.qty" placeholder="Service count" ></b-input></b-col>
              <b-col md="2" class="col-form-label" for="Group"> User <small>(Max)</small> </b-col>
              <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
                <!-- <c-switch :disabled="true" v-if="model.license.data.summary.User" color="info" label v-model="model.license.data.summary.User.use" /> -->
                <div class="checkbox-switch">
                  <input type="checkbox" class="input-checkbox" name="User" id="User" checked="" :disabled="true" v-if="model.license.data.summary.User" v-model="model.license.data.summary.User.use">
                  <div class="checkbox-animate disabled">
                    <span class="checkbox-off">OFF</span>
                    <span class="checkbox-on">ON</span>
                  </div>
                </div>
              </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.User" v-model="model.license.data.summary.User.qty" placeholder="Service count" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row v-if="model.license">
            <b-col md="2" class="col-form-label" for="WSFinder"> WSFinder <small>(Max)</small> </b-col>
            <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
              <!-- <c-switch :disabled="true" v-if="model.license.data.summary.WSFinder" color="info" label v-model="model.license.data.summary.WSFinder.use" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="WSFinder" id="WSFinder" checked="" :disabled="true" v-if="model.license.data.summary.WSFinder" v-model="model.license.data.summary.WSFinder.use">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WSFinder" v-model="model.license.data.summary.WSFinder.qty" placeholder="Service count" ></b-input></b-col>
            <b-col md="2" class="col-form-label" for="WEBCastle"> WEBCastle <small>(Max)</small> </b-col>
            <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
              <!-- <c-switch :disabled="true" v-if="model.license.data.summary.WEBCastle" color="info" label v-model="model.license.data.summary.WEBCastle.use" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="WEBCastle" id="WEBCastle" checked="" :disabled="true" v-if="model.license.data.summary.WEBCastle" v-model="model.license.data.summary.WEBCastle.use">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WEBCastle" v-model="model.license.data.summary.WEBCastle.qty" placeholder="Service count" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row v-if="model.license">
            <b-col md="2" class="col-form-label" for="WMDS"> WMDS <small>(Max)</small> </b-col>
            <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
              <!-- <c-switch :disabled="true" v-if="model.license.data.summary.WMDS" color="info" label v-model="model.license.data.summary.WMDS.use" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="WMDS" id="WMDS" checked="" :disabled="true" v-if="model.license.data.summary.WMDS" v-model="model.license.data.summary.WMDS.use">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WMDS" v-model="model.license.data.summary.WMDS.qty" placeholder="Service count" ></b-input></b-col>
            <b-col md="2" class="col-form-label" for="WFDetector"> WFDetector <small>(Max)</small> </b-col>
            <b-col md="1" class="col-xl-1 col-md-12 d-flex align-self-center">
              <!-- <c-switch :disabled="true" v-if="model.license.data.summary.WFDetect" color="info" label v-model="model.license.data.summary.WFDetect.use" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="WFDetector" id="WFDetector" checked="" :disabled="true" v-if="model.license.data.summary.WFDetect" v-model="model.license.data.summary.WFDetect.use">
                <div class="checkbox-animate disabled">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col md="3"><b-input :disabled="true" v-if="model.license.data.summary.WEBCastle" v-model="model.license.data.summary.WEBCastle.qty" placeholder="Service count" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row class="mb-3">
            <b-col class="col-xl-2 col-md-12 col-form-label">
              Language
            </b-col>
            <b-col class="col-xl-1 col-md-12 d-flex align-self-center">
              <select class="form-control" v-model="model.license.data.info.language">
                <option disabled value="">Please select a language</option>
                <option value="EN">English</option>
                <option value="KO">Korean</option>
              </select>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="2" class="col-form-label" for="Site_License"><span>Site License</span></b-col>
            <b-col md="8"><b-input :type="toggle" v-model="model.license.data.info.key" placeholder="ex) Please enter the license key for the UWSS platform." ></b-input></b-col>
            <b-col md="2">
              <b-button block class="btn btn-cancel" type="button" @click="toggle = toggle == 'password' ? 'text' : 'password';">{{toggle == 'password' ? 'Show' : 'Hide'}}</b-button>
            </b-col>
          </b-row>
          <!-- <div class="row mb-2 mt-2">
            <div class="col-xl-12 col-md-12">
              <div class="text-center">
                <button type="button" @click="confirm_save = true;" class="btn btn-add col-xl-2 mr-2">
                  Apply
                </button>
                <button type="button" class="btn btn-cancel col-xl-2" @click="toggle = toggle == 'password' ? 'text' : 'password'; type = 'license'">
                  {{toggle == 'password' ? 'Show' : 'Hide'}}
                </button>
              </div>
            </div>
          </div> -->
          <hr>
          <b-row>
            <b-col md="2" class="col-form-label"><span>License Auth URL</span></b-col>
            <b-col md="10"><b-input type="text" v-model="model.license.data.info.url" placeholder="ex) Please enter the URL of the server to be authenticated." ></b-input></b-col>
            <!-- <b-col md="2">
              <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'license'">Apply</b-button>
            </b-col> -->
          </b-row>
          <hr>
          <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'license'">Apply</b-button>
        </b-tab>
        <!-- 메일설정 -->
        <b-tab :title="model.mail.code.toUpperCase()" v-if="model.mail.code">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              MAIL
            </div>
          </div>
          <hr>
          <b-row>
            <b-col class="col-form-label" for="From"><span>From</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.mail.data.from" placeholder="ex) f1uwss@f1security.co.kr" ></b-input></b-col>

            <b-col class="col-form-label" for="Username"><span>Username</span></b-col>
            <b-col class="col-xl-4 col-md-12"><b-input v-model="model.mail.data.username" placeholder="ex) user username for SMTP" ></b-input></b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Password"><span>Password</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input type="password" v-model="model.mail.data.password" placeholder="ex) your secret password for SMTP" ></b-input></b-col>
            
            <b-col class="col-form-label" for="PORT"><span>PORT</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.mail.data.port" placeholder="ex) 587" ></b-input></b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col class="col-form-label" for="SMTP_Server"><span>SMTP Server</span></b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center"><b-input v-model="model.mail.data.server" placeholder="ex) smtp.main.org" ></b-input></b-col>
          </b-row>
          <hr>
          <b-button variant="danger" type="button" block @click="confirm_save = true; type = 'mail'">Save</b-button>
        </b-tab>
        <b-tab no-body :title="model.rule.code.toUpperCase()" v-if="model.rule.code">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              RULE
            </div>
          </div>
          <hr>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              WMDS
            </div>
          </div>
          <!-- WMDS -->
          <b-row>
            <b-col class="col-form-label" for="Init"><span>Init</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <!-- <c-switch color="info" label v-model="model.rule.data.wmds.init" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Init" id="Init" checked="" v-model="model.rule.data.wmds.init">
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>

            <b-col class="col-form-label" for="Status"><span>Status</span></b-col>
            <b-col class="col-xl-4 col-md-12">
              <!-- <c-switch color="info" label v-model="model.rule.data.wmds.is_run" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Status" id="Status" v-model="model.rule.data.wmds.is_run">
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Point"><span>Point : cp</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.rule.data.wmds.cp" placeholder="ex) pattern update check point" ></b-input></b-col>

            <b-col class="col-form-label" for="Rule_Server"><span>Rule Server</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.rule.data.wmds.url" placeholder="ex) Rule update remote server" ></b-input></b-col>
          </b-row>
          <hr>
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              WSFinder
            </div>
          </div>
          <!-- WSFinder -->
          <b-row>
            <b-col class="col-form-label" for="Init"><span>Init</span></b-col>
            <b-col class="col-xl-4 col-md-12">
              <!-- <c-switch color="info" label v-model="model.rule.data.wsfinder.init" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Init" id="Init" v-model="model.rule.data.wsfinder.init">
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
            <b-col class="col-form-label" for="Status"><span>Status</span></b-col>
            <b-col class="col-xl-4 col-md-12">
              <!-- <c-switch color="info" label v-model="model.rule.data.wsfinder.is_run" /> -->
              <div class="checkbox-switch">
                <input type="checkbox" class="input-checkbox" name="Status" id="Status" v-model="model.rule.data.wsfinder.is_run">
                <div class="checkbox-animate">
                  <span class="checkbox-off">OFF</span>
                  <span class="checkbox-on">ON</span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Point"><span>Point : cp</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.rule.data.wsfinder.cp" placeholder="ex) pattern update check point" ></b-input></b-col>

            <b-col class="col-form-label" for="Rule_Server"><span>Rule Server</span></b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center"><b-input v-model="model.rule.data.wsfinder.url" placeholder="ex) Rule update remote server" ></b-input></b-col>
          </b-row>
          <hr>
          <b-button variant="danger" type="button" block @click="confirm_save = true; type = 'rule'">Save</b-button>
        </b-tab>
        <!-- 로고 -->
        <!-- <b-tab :title="model.logo.code.toUpperCase()" active v-if="model.logo && model.logo.code"> -->
        <b-tab :title="'CUSTOM'" active v-if="model.logo && model.logo.code">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              CUSTOM
            </div>
          </div>
          <hr>
          <b-row>
            <b-col class="col-form-label" for="Slogan">
              Slogan
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.slogan" placeholder="ex) F1-UWSS" ></b-input>
              <br>
              <small>* You can set the logo displayed on the screen where the user login.</small>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Business_Number">
              Logo
            </b-col>
            <b-col md="10">
              <picture-input
                :z-index="2"
                radius="3"
                :prefill="model.logo.data.image"
                v-show="!confirm_save && !confirm_refresh"
                ref="pictureInput"
                height="150" min-height="150" width="800" max-width="800" max-height="800"
                accept="image/*" size="2" button-class="btn btn-dark"
                :custom-strings="{
                  upload: '<h1>test!</h1>',
                  drag: '<small>Drag & Drop<small>',
                }"
                @change="logo_change">
              </picture-input>
              <br>
              <small>* You can set the login slogan that is displayed on the screen where the user login.  <span class='text-danger'>(Minimum Recommended Size : 800px X 200px)</span> </small>
              <b-button size="sm" class="m-1 float-right" variant="warning" @click="model.logo.data.image = ''">Clear</b-button>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Logo_favicon_ico">
              Logo favicon.ico
              <b-badge variant="danger" v-if="favicon">Using</b-badge>
            </b-col>
            <b-col md="10" class="text-center">
              <p v-if="!favicon">
                <b-form-file
                placeholder="Choose a file or drop it here..."
                @input="input_favicon"
                ></b-form-file>
              </p>
              <b-img v-else :src="favicon"></b-img>
              <hr>
              <small>* favicon is  shortcut icon, website icon, tab icon, URL icon, or bookmark icon  <span class='text-danger'>(Minimum Recommended Size : 800px X 200px)</span> </small>
              <b-button size="sm" class="m-1 float-right" variant="warning" @click="favicon = ''">Clear</b-button>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label">
              Support Email
              <br>
              <small>(CC reference all)</small>
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.support" placeholder="ex) support@f1security.co.kr,uwss@f1security.co.kr" ></b-input>
              <br>
              <small>* Authentication-related mail, such as finding passwords, is referenced to all mail guides for technical support</small>
              <br>
              <small>[ex) admin@f1security.co.kr,support@f1secuirty.co.kr...]</small>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Maual_URL">
              Manual URL
            </b-col>
            <b-col class="col-xl-4 col-md-12 align-self-center">
              <b-input v-model="model.logo.data.manual" placeholder="ex) https://f1security.co.kr/manual.pdf" ></b-input>
              <br>
              <small>* Default is F1-UWSS Manual URL <br>(<b-button variant="link" @click="redirect_manual()">{{config.manual}}</b-button>)</small>
            </b-col>
            <b-col class="col-form-label" for="Help_Email">
              Help Email
            </b-col>
            <b-col class="col-xl-4 col-md-12 align-self-center">
              <b-input v-model="model.logo.data.help" placeholder="ex) help@uwss.kr" ></b-input>
              <br>
              <small>Mail address that notifies end customers, partners of a public reply.  You will receive inquiries from the users via the mail you set up</small>
            </b-col>
          </b-row>
          <!-- <hr> -->
          <!-- <b-row>
            <b-col md="2">
              Address
            </b-col>
            <b-col md="10">
              <b-input v-model="model.logo.data.address" placeholder="ex) #1402, 234, Beotkkot-ro, Geumcheon-gu, Seoul, Republic of Korea." ></b-input>
              <br>
              <small>This address will be shown in the mail</small>
            </b-col>
          </b-row> -->
          <hr>
          <b-button v-if="model.invoice.data && model.invoice.data.image" block variant="primary" type="button" @click="clear_logo">Clear</b-button>
          <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'logo'">Apply</b-button>
        </b-tab>
        <!-- 인보이스 -->
        <b-tab :title="'Invoice'" active v-if="model.invoice && model.invoice.code">
          <div class="d-flex flex-wrap align-items-center">
            <div class="title mr-auto">
              Invoice
            </div>
          </div>
          <hr>
          <b-row>
            <b-col class="col-form-label" for="Company">
              Company
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.company" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
            <b-col class="col-form-label" for="Contact">
              Contact
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input v-model="model.invoice.data.contact" placeholder="ex) +82 070-4640-3030" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="col-form-label" for="Business_Number">
              Business Number
            </b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.business_number" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="col-form-label" for="Address">
              Address
            </b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.company_address" placeholder="ex) F1 Security office location" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="col-form-label" for="Issuer">
              Issuer
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.issuer" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
            <b-col class="col-form-label" for="Issuer_Email">
              Issuer Email
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input v-model="model.invoice.data.issuer_email" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="col-form-label" for="Bank_Name">
              Bank Name
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.bank_name" placeholder="ex) F1security Bank" ></b-input>
            </b-col>
            <b-col class="col-form-label" for="Bank_Number">
              Bank Number
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input v-model="model.invoice.data.bank_number" placeholder="ex) -" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col md="2">
              Bank Swift Code
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.swift_code" placeholder="Optional" ></b-input>
            </b-col>
            <b-col class="col-form-label" for="Account_Holder">
              Account Holder
            </b-col>
            <b-col class="col-xl-4 col-md-12">
              <b-input v-model="model.invoice.data.account_holder" placeholder="ex) F1 Security Inc" ></b-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col class="col-form-label" for="Bank_branch">
              Bank branch
            </b-col>
            <b-col class="col-xl-10 col-md-12 d-flex align-self-center">
              <b-input v-model="model.invoice.data.bank_branch" placeholder="Optional" ></b-input>
            </b-col>
          </b-row>
          <div class="row mb-2">
            <div class="col-xl-12 col-md-12 d-flex align-self-center">
              * This information is shown when an invoice is issued on the platform.
            </div>
          </div>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Issue_Day">
              Issue Day
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input type="number" v-model="model.invoice.data.issue_day" placeholder="default day is 1" ></b-input>
            </b-col>
            <div class="col-xl-6 col-md-12 d-flex align-self-center">
              choice invoice issue day of the month
            </div>
          </b-row>
          <b-row class="mt-3">
            <b-col class="col-form-label" for="Pay_Day">
              Pay Day
            </b-col>
            <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
              <b-input type="number" v-model="model.invoice.data.pay_day" placeholder="default day is 5" ></b-input>
            </b-col>
            <div class="col-xl-6 col-md-12 d-flex align-self-center">
              Specifies the date of automatic payment of invoices issued as deposits
            </div>
          </b-row>

          <hr>
          <b-button v-if="model.invoice.data && model.invoice.data.image" block variant="primary" type="button" @click="clear_logo">Clear</b-button>
          <b-button block variant="danger" type="button" @click="confirm_save = true; type = 'invoice'">Apply</b-button>
        </b-tab>
      </b-tabs>
    </b-card>

    <!-- 시스템의 기본 서비스 관리 추가 -->
    <ServiceList />
    <!-- <b-card border-variant="primary" id="list">
      <template slot="header">
        <i class='fa fa-align-justify'></i> UWSS Base Service
      </template>
      <b-row>
        <b-col md="9">
          <h4>
            <b-badge variant="danger">* Notice</b-badge>
          </h4>
          - Newly created services are available to partners after the system is created.
        </b-col>
        <b-col md="3">
          <b-button size="sm" variant="success" class="pull-right mx-1" @click="service_new = true; confirm_info = true; service = {}"> New Registration </b-button>
          <b-button size="sm" variant="info" class="pull-right mx-1" @click="$refs._list.refresh()"> Refresh </b-button>
        </b-col>
      </b-row>
      <hr> -->



      <!-- <b-table hover striped small responsive="sm" foot-clone ref="_list" show-empty empty-text="not found"
        :items="load_service" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="is_alive" slot-scope="row">
          <c-switch @change="status_change($event, row.item, 'is_alive')" color="warning" label v-model="row.item.status" />
        </template>
        <template slot="name" slot-scope="row">
          <b-btn @click="status_change(row.item, row.item, 'is_del')" variant="outline-danger" size="sm">Delete</b-btn>
          {{row.item.name}}
        </template>
        <template slot="list_price" slot-scope="row">{{row.item.list_price | dollar}}</template>
        <template slot="min_price" slot-scope="row">{{row.item.min_price | dollar}}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">Select</b-btn>
        </template>
      </b-table> -->
    <!-- </b-card> -->

    <!-- 기존 파트너의 가격 수정 여부 확인 모달 -->
    <b-modal hide-footer title="System service price was changed"  class="modal-warning" v-model="confirm_all">
      you want to apply a new price to my existing partner?
      if press "only update the price.", Accounts created after application will be affected by the price updated
      <b-button class="mt-3" variant="outline-warning" block @click="confirm_all = false; upsert_service()">only update the price.</b-button>
      <b-button class="mt-3" variant="outline-danger" block @click="service.apply_all = true; upsert_service()">Apply the price</b-button>
    </b-modal>
    <!-- 미사용 확인 모달 -->
    <b-modal title="System update info"  class="modal-danger" header-bg-variant="danger" v-model="confirm_save" @ok="confirm_refresh = true" ok-variant="outline-danger" cancel-variant="outline-dark">
      Are you sure you want to update this info?
    </b-modal>
    <!-- 적용을 위한 페이지 새로고침 안내 -->
    <b-modal title="System refresh notice" ok-only v-model="confirm_refresh" @ok="save" ok-variant="outline-info" cancel-variant="outline-dark">
      A page refresh is required to apply the changed settings,
      <br>
      which will be automatically refreshed 3 seconds after applying the settings.
      <br>
      Don't be surprised.😉
    </b-modal>
    <!-- english manual notice -->
    <b-modal title="Manual Notice"  class="modal-danger" header-bg-variant="warning"  v-model="alert" ok-variant="outline-warning" ok-only>
      Currently, the manual only supports Korean language version.
      <br>
      We will prepare an English manual as soon as possible.
    </b-modal>
    </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>